    <ds-alert *ngIf="isSuccess"
      class=" mb-8"
      variant="success"
     >
      <div class="d-flex flex-column flex-md-row">
        <div class="flex-grow-1 d-flex">
          <ds-icon
            [name]="iconPrefix + '-icon-checkmark-outlined'"
            class="mr-8"
            [color]="'success'">
          </ds-icon>
          <div>
             <p class="text-body">
            <span>
              <div>
                <b>{{ 'passkey.register.success' | translate }}</b>
              </div>
              <div style="margin-left: -30px;">
               {{ 'passkey.register.successDesc' | translate }}
              </div>
            </span>
            </p>
          </div>
        </div>
      </div>
    </ds-alert>

    <ds-alert *ngIf="!isSuccess"
      class=" mb-8"
      variant="error"
     >
      <div class="d-flex flex-column flex-md-row">
        <div class="flex-grow-1 d-flex">
          <ds-icon
            [name]="iconPrefix + '-icon-error-filled'"
            class="mr-8"
            [color]="'error'">
          </ds-icon>
          <div>
             <p class="text-body">
            <span>
              <div>
                <b>{{ 'passkey.register.error' | translate }}</b>
              </div>
              <div style="margin-left: -30px;">
               {{ 'passkey.register.errorDesc' | translate }}
              </div>
            </span>
            </p>
          </div>
        </div>
      </div>
    </ds-alert>

<button ds-button
        type="submit"
        role="button"
        class="w-100 mb-16"
        (click)="onPasskeySuccessContinueClick()"
        title="{{ gotoLink | translate }}">
        <span>{{ gotoLink | translate }}</span>
</button>